exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag__tag__5e4t5{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;height:28px;padding:0 12px;border:1px solid -wix-colors-textColor;color:-wix-colors-textColor;font-size:12px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;text-decoration:none;transition:border .2s,color .2s,border-radius .2s}.tag__tag__5e4t5:hover{color:-wix-colors-textColor-70}.tag__rounded__1nygW{border-radius:999px}.tag__inner__4CUYN{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"tag": "tag__tag__5e4t5",
	"rounded": "tag__rounded__1nygW",
	"inner": "tag__inner__4CUYN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/tags-cloud/tag/tag.styl
// module id = 1867
// module chunks = 1 2